import { createSelector } from 'reselect'
import { values } from 'util/objects'
import { foldersByIdSelector } from './foldersByIdSelector'

// Its VERY important we dont return a new object all the time from this base selector...
// FIXME: values() will return a new object all the time...
export const selectFolders = createSelector(foldersByIdSelector, byId =>
  values(byId)
)
